import { Fragment } from 'react/jsx-runtime';
import CreateGeneralProjectCard from './CreateGeneralCard';
import CreateHackathonProjectCard from './CreateHackathonCard';
import CreateMeProjectCard from './CreateMeCard';
import CreatePodiumCard from './CreatePodiumCard';
import CreateRankingCard from './CreateRankingCard';
import ProjectCardProps from './ProjectCardProps';
import CreateSimpleProjectCard from './CreateSimpleCard';

export type ProjectCardsMode =
  | 'me'
  | 'hackathon'
  | 'general'
  | 'ranking'
  | 'podium'
  | 'simple';

type ProjectCardMode = {
  mode: ProjectCardsMode;
  rank?: number;
};

type ProjectCardsFactoryProps = ProjectCardProps & ProjectCardMode;

export default function ProjectCardsFactory({
  mode,
  ...projectCardProps
}: ProjectCardsFactoryProps) {
  if (mode === 'podium') {
    return <CreatePodiumCard {...projectCardProps} />;
  }
  if (mode === 'ranking') {
    return <CreateRankingCard {...projectCardProps} />;
  }
  if (mode === 'hackathon') {
    return <CreateHackathonProjectCard {...projectCardProps} />;
  }

  if (mode === 'general') {
    return <CreateGeneralProjectCard {...projectCardProps} />;
  }

  if (mode === 'me') {
    return <CreateMeProjectCard {...projectCardProps} />;
  }

  if (mode === 'simple') {
    return <CreateSimpleProjectCard {...projectCardProps} />;
  }

  return <Fragment />;
}
